export default __webpack_public_path__ + "cf4d1054be00b6a4b914f16f543f4fa6.png";